import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";

/**
 * Cached result so we only hit the Worker endpoint once per tab refresh.
 */
let cached: {
  fetched: boolean;
  waitlist: boolean;
  error?: string;
} = {
  fetched: false,
  waitlist: false,
};

export function useRegistrationStatus() {
  const [loading, setLoading] = useState(!cached.fetched);
  const [waitlist, setWaitlist] = useState(cached.waitlist);
  const [error, setError] = useState<string | undefined>(cached.error);

  useEffect(() => {
    if (cached.fetched) {
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const res = await supabase.functions.invoke("registration_status");

        if (cancelled) return;

        if (res.error || !res.data) {
          const errorMsg = res.error?.message ?? 'Unknown error';
          console.error("registration_status failed", errorMsg);
          cached = { fetched: true, waitlist: false, error: errorMsg };
          setError(errorMsg);
          setLoading(false);
          return;
        }

        cached = { fetched: true, waitlist: Boolean((res.data as { waitlist?: boolean }).waitlist) };
        setWaitlist(cached.waitlist);
      } catch (err: unknown) {
        console.error("registration_status error", err);
        cached = { fetched: true, waitlist: false, error: String(err) };
        setError(String(err));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return { loading, waitlist, error };
}
